/* Aerastrip — поведение сайта. Единственный кастомный JS. */
(function () {
  'use strict';
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mobile = matchMedia('(max-width: 720px)');
  var root = document.documentElement;

  /* стартовые смещения включаем только если скрипт реально выполняется */
  if (!reduce) root.classList.add('aera-js');

  function playIntro() {
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { root.classList.add('aera-in'); });
    });
  }

  /* ---------------- лоадер: один раз за сессию ---------------- */
  function initLoader() {
    var el = document.getElementById('aera-loader');
    if (!el) { playIntro(); return; }
    var seen = false;
    try { seen = sessionStorage.getItem('aera_seen') === '1'; } catch (e) {}
    if (seen || reduce || (window.Shopify && Shopify.designMode)) {
      el.classList.add('done');
      playIntro();
      return;
    }
    setTimeout(function () {
      el.classList.add('done');
      playIntro();
      try { sessionStorage.setItem('aera_seen', '1'); } catch (e) {}
    }, 2450);
  }

  /* ---------------- дыхание воздуха в герое ---------------- */
  function initBreath() {
    if (reduce) return;
    var l = document.querySelector('.aera-breath--l');
    var r = document.querySelector('.aera-breath--r');
    if (!l || !r) return;
    var period = 5000, t0 = performance.now();      /* 12 циклов в минуту */
    (function step(t) {
      var ph = ((t - t0) % period) / period;
      var e = (1 - Math.cos(ph * Math.PI * 2)) / 2;
      var o = (0.10 + e * 0.55).toFixed(3);
      l.style.opacity = o; r.style.opacity = o;
      requestAnimationFrame(step);
    })(t0);
  }

  /* ---------------- видео при наведении ---------------- */
  function initHeroMedia() {
    document.querySelectorAll('.aera-panel').forEach(function (p) {
      var v = p.querySelector('video');
      if (!v) return;
      p.addEventListener('mouseenter', function () {
        var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
      });
      p.addEventListener('mouseleave', function () { v.pause(); });
    });
  }

  /* ---------------- точки под курсором на панелях ---------------- */
  function initDots() {
    if (reduce) return;
    document.querySelectorAll('.aera-nm').forEach(function (g) {
      g.addEventListener('pointermove', function (e) {
        var r = g.getBoundingClientRect();
        g.style.setProperty('--mx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
        g.style.setProperty('--my', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
      });
    });
  }

  /* ---------------- скролл: панорама букв, параллакс, футер ---------------- */
  var pans = [], parEls = [], bands = [], fpar = null, ticking = false;

  function collectScroll() {
    pans = [].slice.call(document.querySelectorAll('.aera-panx'));
    fpar = document.querySelector('.aera-fpar');
    parEls = [];
    bands = [];
    if (reduce) return;

    function add(sel, sp) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (el.closest('.aera-slider')) return;
        /* панель товара наезжает на кадр — параллакс сдвинул бы её со стыка */
        if (el.classList.contains('aera-pover')) return;
        el.classList.add('aera-par');
        parEls.push([el, sp]);
      });
    }

    /* перебивки держим приколотыми всегда: это и есть «картинка стоит,
       страница едет», ради чего блок задумывался */
    bands = [].slice.call(document.querySelectorAll('.aera-band__bg'));

    if (mobile.matches) {
      /* на телефоне двигаем только фотографии: текстовые панели от параллакса
         дёргаются и наезжают друг на друга */
      add('.aera-sec .aera-well', 0.06);
      return;
    }

    add('.aera-sec .aera-well', 0.085);
    add('.aera-sec .aera-nm', -0.032);
    add('.aera-sec .aera-post', 0.045);
    add('.aera-sec .aera-showcase', 0.022);
    add('.aera-sec .aera-mapbox', 0.03);
  }

  function onScroll() {
    var vh = window.innerHeight || 800, half = vh / 2, i, b;
    for (i = 0; i < pans.length; i++) {
      b = pans[i].getBoundingClientRect();
      var p = Math.max(0, Math.min(1, (vh - b.top) / (vh + b.height)));
      pans[i].style.setProperty('--bgx', (8 + p * 84).toFixed(1) + '%');
    }
    for (i = 0; i < parEls.length; i++) {
      var el = parEls[i][0], sp = parEls[i][1];
      b = el.getBoundingClientRect();
      if (b.bottom < -240 || b.top > vh + 240) continue;
      var y = -((b.top + b.height / 2) - half) * sp;
      if (y > 44) y = 44; else if (y < -44) y = -44;
      el.style.setProperty('--py', y.toFixed(1) + 'px');
    }
    for (i = 0; i < bands.length; i++) {
      var bg = bands[i], bb = bg.parentElement.getBoundingClientRect();
      if (bb.bottom < -100 || bb.top > vh + 100) continue;
      /* компенсируем смещение полосы — картинка остаётся стоять относительно окна */
      bg.style.transform = 'translate3d(0,' + (-bb.top).toFixed(1) + 'px,0)';
    }
    if (fpar && !reduce) {
      var fr = fpar.parentElement.getBoundingClientRect();
      var q = Math.max(-1, Math.min(1, (vh - fr.top) / (vh + fr.height) * 2 - 1));
      fpar.style.transform = 'translate3d(0,' + (q * -9).toFixed(2) + '%,0)';
    }
    ticking = false;
  }

  function initScroll() {
    collectScroll();
    function queue() {
      if (!ticking) { ticking = true; requestAnimationFrame(onScroll); }
    }
    /* события scroll не всплывают: если страницу прокручивает не window,
       а внутренний контейнер темы, слушатель на window молчит.
       Ловим ещё и на document в фазе перехвата — там видно любой скроллер. */
    addEventListener('scroll', queue, { passive: true });
    document.addEventListener('scroll', queue, { passive: true, capture: true });
    addEventListener('resize', onScroll, { passive: true });
    onScroll();
  }

  /* ---------------- появление секций ---------------- */
  function initReveal() {
    var els = document.querySelectorAll('.aera-reveal:not(.in)');
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (el) { el.classList.add('in'); el.classList.add('aera-settled'); });
      return;
    }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        el.classList.add('in');
        io.unobserve(el);
        /* после выезда отпускаем трансформ, чтобы параллакс шёл кадр в кадр */
        setTimeout(function () { el.classList.add('aera-settled'); }, 850);
      });
    }, { threshold: 0.1 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------------- слайдер отзывов ---------------- */
  function initSlider(root) {
    var sl = root.querySelector('.aera-slider');
    if (!sl || sl.dataset.ready) return;
    sl.dataset.ready = '1';
    var pv = root.querySelector('[data-sl="prev"]');
    var nx = root.querySelector('[data-sl="next"]');
    var fl = root.querySelector('.aera-slfade--l');
    var fr = root.querySelector('.aera-slfade--r');

    function edges() {
      var s = sl.scrollLeft < 8;
      var e = sl.scrollLeft > sl.scrollWidth - sl.clientWidth - 8;
      if (pv) pv.disabled = s;
      if (nx) nx.disabled = e;
      if (fl) fl.classList.toggle('off', s);
      if (fr) fr.classList.toggle('off', e);
    }
    function step() {
      var c = sl.firstElementChild;
      return c ? c.getBoundingClientRect().width + 34 : 340;
    }
    if (pv) pv.addEventListener('click', function () { sl.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (nx) nx.addEventListener('click', function () { sl.scrollBy({ left: step(), behavior: 'smooth' }); });
    sl.addEventListener('scroll', function () { requestAnimationFrame(edges); }, { passive: true });
    addEventListener('resize', edges, { passive: true });
    edges();

    var down = false, sx = 0, sc = 0, moved = 0, vel = 0, last = 0, lastT = 0, raf = 0;
    sl.addEventListener('pointerdown', function (e) {
      /* на тач-экране нативная прокрутка работает лучше нашей:
         перехват указателя ломал свайп по отзывам на телефоне */
      if (e.pointerType !== 'mouse') return;
      if (e.button !== 0) return;
      down = true; moved = 0; vel = 0;
      sx = e.clientX; sc = sl.scrollLeft; last = e.clientX; lastT = performance.now();
      sl.classList.add('dragging');
      cancelAnimationFrame(raf);
      try { sl.setPointerCapture(e.pointerId); } catch (_) {}
    });
    sl.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - sx;
      moved = Math.max(moved, Math.abs(dx));
      sl.scrollLeft = sc - dx;
      var now = performance.now(), dt = now - lastT;
      if (dt > 0) { vel = (e.clientX - last) / dt; last = e.clientX; lastT = now; }
    });
    function release() {
      if (!down) return;
      down = false;
      sl.classList.remove('dragging');
      var v = vel * 18;
      (function glide() {
        if (Math.abs(v) < 0.4) return;
        sl.scrollLeft -= v; v *= 0.945;
        raf = requestAnimationFrame(glide);
      })();
    }
    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (ev) {
      sl.addEventListener(ev, release);
    });
    sl.addEventListener('click', function (e) {
      if (moved > 6) { e.preventDefault(); e.stopPropagation(); }
    }, true);
    sl.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  function initSliders() {
    document.querySelectorAll('[data-aera-slider]').forEach(initSlider);
  }


  /* ---------------- карта: точки продаж ---------------- */
  function initMap(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';

    var card  = root.querySelector('.aera-poi');
    var pins  = [].slice.call(root.querySelectorAll('.aera-pin'));
    var chips = [].slice.call(document.querySelectorAll('.aera-chip-poi'));
    if (!card || !pins.length) return;

    var nameEl  = card.querySelector('.aera-poi__name');
    var addrEl  = card.querySelector('.aera-poi__addr');
    var hoursEl = card.querySelector('.aera-poi__hours');
    var linkEl  = card.querySelector('.aera-poi__link');
    var closeEl = card.querySelector('.aera-poi__x');
    var openId  = null;

    function pinFor(id) {
      for (var i = 0; i < pins.length; i++) {
        if (pins[i].dataset.poi === id) return pins[i];
      }
      return null;
    }

    function close() {
      openId = null;
      card.classList.remove('is-open');
      setTimeout(function () { if (!openId) card.hidden = true; }, 300);
      pins.forEach(function (p) { p.classList.remove('is-on'); p.setAttribute('aria-expanded', 'false'); });
      chips.forEach(function (c) { c.classList.remove('is-on'); c.setAttribute('aria-expanded', 'false'); });
    }

    function open(id) {
      var pin = pinFor(id);
      if (!pin) return;
      if (openId === id) { close(); return; }
      openId = id;

      pins.forEach(function (p) {
        var on = p === pin;
        p.classList.toggle('is-on', on);
        p.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
      chips.forEach(function (c) {
        var on = c.dataset.poi === id;
        c.classList.toggle('is-on', on);
        c.setAttribute('aria-expanded', on ? 'true' : 'false');
      });

      nameEl.textContent  = pin.dataset.name  || '';
      addrEl.textContent  = pin.dataset.addr  || '';
      hoursEl.textContent = pin.dataset.hours || '';
      hoursEl.hidden = !pin.dataset.hours;
      if (pin.dataset.url) {
        linkEl.href = pin.dataset.url;
        linkEl.hidden = false;
      } else {
        linkEl.hidden = true;
      }

      if (window.matchMedia('(max-width: 620px)').matches) {
        /* мобильная раскладка кладёт карточку внизу экрана —
           инлайновые координаты пина её ломали */
        card.style.left = '';
        card.style.top = '';
      } else {
        card.style.left = pin.style.left;
        card.style.top  = pin.style.top;
      }
      card.hidden = false;
      requestAnimationFrame(function () { card.classList.add('is-open'); });
    }

    pins.forEach(function (p) {
      p.addEventListener('click', function (e) { e.stopPropagation(); open(p.dataset.poi); });
    });
    chips.forEach(function (c) {
      c.addEventListener('click', function (e) {
        e.stopPropagation();
        open(c.dataset.poi);
        var pin = pinFor(c.dataset.poi);
        if (pin) pin.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
    if (closeEl) closeEl.addEventListener('click', function (e) { e.stopPropagation(); close(); });
    card.addEventListener('click', function (e) { e.stopPropagation(); });
    document.addEventListener('click', function () { if (openId) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && openId) close(); });
  }

  function initMaps() {
    document.querySelectorAll('[data-aera-map]').forEach(initMap);
  }


  /* ---------------- переход между страницами ---------------- */
  function initPageFly() {
    /* приход: снять белое полотно, поставленное инлайн-скриптом в <head> */
    if (root.classList.contains('aera-arriving')) {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { root.classList.add('aera-arrived'); });
      });
      setTimeout(function () {
        root.classList.remove('aera-arriving', 'aera-arrived');
      }, 700);
    }

    if (reduce) return;

    /* уход */
    var fly = document.createElement('div');
    fly.className = 'aera-fly';
    fly.setAttribute('aria-hidden', 'true');
    /* только стрелка: оранжевая перекладина в перелёте читается как логотип,
       а нужен один знак направления */
    fly.innerHTML =
      '<svg viewBox="0 0 1743 1826" focusable="false">' +
      '<path fill-rule="evenodd" clip-rule="evenodd" fill="#26292A" ' +
      'd="M871.5 0L1743 1826H1390.25L871.5 726.25L352.75 1826H0L871.5 0Z"/>' +
      '</svg>';
    document.body.appendChild(fly);

    var going = false;

    document.addEventListener('click', function (e) {
      if (going || e.defaultPrevented) return;
      if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

      var a = e.target.closest && e.target.closest('a[href]');
      if (!a) return;
      if (a.target && a.target !== '_self') return;
      if (a.hasAttribute('download')) return;

      var href = a.getAttribute('href') || '';
      if (!href || href.charAt(0) === '#') return;
      if (/^(mailto:|tel:|javascript:)/i.test(href)) return;

      var url;
      try { url = new URL(a.href, location.href); } catch (_) { return; }
      if (url.origin !== location.origin) return;
      if (url.pathname === location.pathname && url.search === location.search) return;

      e.preventDefault();
      going = true;
      try { sessionStorage.setItem('aera_nav', '1'); } catch (_) {}
      fly.classList.add('on');
      setTimeout(function () { location.href = url.href; }, 340);
    });

    /* возврат из истории: снять всё, иначе полотно зависнет */
    addEventListener('pageshow', function () {
      fly.classList.remove('on');
      root.classList.remove('aera-arriving', 'aera-arrived');
      going = false;
    });
  }

  /* ---------------- запуск ---------------- */
  function boot() {
    initLoader();
    initBreath();
    initHeroMedia();
    initDots();
    initScroll();
    initReveal();
    initSliders();
    initMaps();
    initPageFly();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }

  /* пересборка после перерисовки секции в редакторе темы */
  document.addEventListener('shopify:section:load', function () {
    collectScroll(); onScroll(); initReveal(); initSliders(); initDots(); initHeroMedia(); initMaps();
  });
})();
